import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage, AngularFireUploadTask, AngularFireStorageReference } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Account } from '../models/account';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Account>;
  item: Observable<Account>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
    return this.db.collection<Account>('accounts', ref => ref.orderBy('displayName')).snapshotChanges();
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Account>('accounts/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  async insert(account: Account) {
    // const createFirebaseAccount = this.ff.functions.httpsCallable('createFirebaseAccount');
    // return createFirebaseAccount(account)

    const createFirebaseAccount = this.ff.httpsCallable('createFirebaseAccount');
    return createFirebaseAccount(account);

  }

  async update(account: Account) {
    const updateFirebaseAccount = this.ff.httpsCallable('updateFirebaseAccount');
    return updateFirebaseAccount(account)
  }

  delete(id: any) {
    return this.db.collection('accounts').doc(id).delete();
  }

  previewImage(event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[0];
    }
  }

  uploadImage(file, account_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("photoURL/" + account_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updatePhotoURL(account_id, url)
          this.objectImage = ""
        });
      }))
      .subscribe();
  }

  async updatePhotoURL(id: any, photoURL: any) {
    const updateFirebasePhotoURL = this.ff.httpsCallable('updateFirebasePhotoURL');
    return updateFirebasePhotoURL({ id: id, photoURL: photoURL })
    /*
      .then(() => { })
      .catch((error) => {
        console.log("update photoURL error: " + JSON.stringify(error))
      })
        */
  }

  async changePassword(id, password) {
    const updateFirebasePassword = this.ff.httpsCallable('updateFirebasePassword');
    return updateFirebasePassword({ id: id, password: password })
  }

  makeMsgError(errorsCode){
    let msgError:string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
       break;
      case "auth/phone-number-already-exists":
        msgError = "Este telefone já está em uso"
        break;
      case "auth/invalid-phone-number":
        msgError = "Telefone inválido. Muito longo"
        break;
      case "auth/invalid-password":
        msgError = "Senha deve conter, ao menos, 6 digitos"
        break;
    }

    return msgError
  }
}
